import styled from 'styled-components'
import Cleave from 'cleave.js/react'
import { cn, inputVariants, textareaVariants } from '@cutilei/ui'

/*
  A caixa de texto do @cutilei/ui (Input e Textarea), no tamanho `sm` (36 px), para os campos que as
  telas definem no próprio styles.js. A definição continua um styled-component com o mesmo nome, e
  as telas não mudam:

    export const Input = styled(BaseInput)`
      margin: 0px 5px;
    `

  - O visual vem das classes da lib: borda, cantos, texto à esquerda, placeholder e anel de foco. O
    CSS da definição fica só com o layout, porque ele vem depois das classes e as venceria.
  - O `data-slot` liga o reset da lib (fonte e borda do navegador), que o site aplica só aos
    elementos da lib, porque não usa o preflight do Tailwind.
  - A mensagem de erro continua sendo da tela, embaixo do campo.
*/

const inputLook = () => ({ 'data-slot': 'input', className: cn(inputVariants({ size: 'sm' })) })

export const BaseInput = styled.input.attrs(inputLook)``

/* O Cleave repassa ao <input> as props que não são dele, e com elas a classe e o data-slot. */
export const BaseMaskedInput = styled(Cleave).attrs(inputLook)``

export const BaseTextArea = styled.textarea.attrs(() => ({
  'data-slot': 'textarea',
  className: cn(textareaVariants())
}))``
